import React from 'react'

const ProfileSectionSummaryQualifications = ({ section }) => {
  if (!section.additional) {
    return null
  }

  const summarize = (title, description) => {
    return (
      <div>
        <h5>{title}</h5>
        <p>{description}</p>
      </div>
    )
  }
  const resumeButton = () => {
    if (section.additional.resumeUrl) {
      return (
        <a
          className="btn btn-success pull-right small"
          id="viewresume"
          href={section.additional.resumeUrl}>
          View Resume
        </a>
      )
    }

    return null
  }

  return (
    <div>
      {resumeButton()}
      {section.additional.workHistory
        ? summarize(
            section.additional.workHistory.title,
            section.additional.workHistory.description
          )
        : null}
      {section.additional.educationHistory
        ? summarize(
            section.additional.educationHistory.title,
            section.additional.educationHistory.description
          )
        : null}
    </div>
  )
}

export default ProfileSectionSummaryQualifications
